import { useEffect } from "react";
import { ensureNamespaceLoaded } from "./lazyNamespaces";

/**
 * Pré-carrega namespaces lazy conforme a rota (MainLayout).
 */
export function useLazyI18nNamespaces(pathname) {
  useEffect(() => {
    const p = pathname || "";
    const tasks = [];

    if (p.startsWith("/products")) tasks.push(ensureNamespaceLoaded("products"));
    if (
      p.startsWith("/settings") ||
      p.startsWith("/categories") ||
      p.startsWith("/coupons") ||
      p.startsWith("/banners") ||
      p.startsWith("/contents") ||
      p.startsWith("/pipeline") ||
      p.startsWith("/sales-pipeline") ||
      p.startsWith("/clients") ||
      p.startsWith("/agents") ||
      p.startsWith("/awareness-stages") ||
      p.startsWith("/pipeline-stages") ||
      p.startsWith("/campaigns") ||
      p.startsWith("/surveys") ||
      p.startsWith("/user-details") ||
      p.startsWith("/user-plan")
    ) {
      tasks.push(ensureNamespaceLoaded("settings"));
    }
    if (p === "/" || p.startsWith("/chat")) tasks.push(ensureNamespaceLoaded("chat"));
    if (p.includes("/settings/chatbot")) tasks.push(ensureNamespaceLoaded("chatbot"));
    if (p.startsWith("/dashboard")) {
      tasks.push(ensureNamespaceLoaded("dashboard"));
      tasks.push(ensureNamespaceLoaded("onboarding"));
    }

    void Promise.all(tasks);
  }, [pathname]);
}
